import { createSlice } from '@reduxjs/toolkit';
import { LocalStorageTypes } from '../../models/localstorage';
import {
  clearLocalStorage,
  getLocalStorage,
  persistLocalStorage,
  setLocalStorage,
} from '../../utilities/localstorage.utility';

export const ClientEmptyState = {
  clients: [],
  selectedClient: null,
  selectedClientMultiple: [],
};

export const ClientKey = 'clients';

export const clientsSlice = createSlice({
  name: 'clients',
  initialState: getLocalStorage(LocalStorageTypes.CLIENTS)
    ? JSON.parse(getLocalStorage(LocalStorageTypes.CLIENTS))
    : ClientEmptyState,
  reducers: {
    setClients: (state, action) => {
      const result = { ...state, ...action.payload };
      setLocalStorage(LocalStorageTypes.CLIENTS, result);
      return result;
    },
    updateSelectedClient: (state, action) => {
      const result = { ...state, selectedClient: action.payload };
      persistLocalStorage(ClientKey, result);
      return result;
    },
    updateSelectedClientMultiple: (state, action) => {
      const result = { ...state, selectedClientMultiple: action.payload };
      persistLocalStorage(ClientKey, result);
      return result;
    },
    resetClients: () => {
      clearLocalStorage('clients');
      return ClientEmptyState;
    },
  },
});

export const {
  setClients,
  updateSelectedClient,
  updateSelectedClientMultiple,
  resetClients,
} = clientsSlice.actions;

export default clientsSlice.reducer;
